import * as React from 'react';
import { StyleSheet, View, Text, Image, TouchableOpacity } from 'react-native';
import { useLocation } from 'react-router';
import { font } from '../../style/text';
import color from '../../style/color';
import { useIsFrench, useCyclingText, LottieWithText, getPostPaymentTexts } from './giftCardPaymentUtils';

const logo = { uri: '/assets/images/logos/logo-with-title.svg' };

/**
 * Success page shown after a successful Flow payment redirect.
 * The tab stays open while the extension delivers the gift card, then closes automatically.
 */
export default function GiftCardPaymentSuccessPage() {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);
    const numberOfCards = parseInt(urlSearchParams.get('numberOfCards') ?? '1', 10) || 1;
    const isFrench = useIsFrench();
    const cyclingText = useCyclingText(getPostPaymentTexts(isFrench, numberOfCards));
    const [isTimedOut, setIsTimedOut] = React.useState(false);

    React.useEffect(() => {
        const timer = setTimeout(() => setIsTimedOut(true), 30000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <View style={styles.page}>
            <View style={styles.header}>
                <Image source={logo} style={styles.headerLogo} />
            </View>
            <View style={styles.centeredContent}>
                {isTimedOut ? (
                    <View style={styles.messageContainer}>
                        <Text style={styles.pageHeading}>
                            {isFrench ? 'Cela prend plus de temps que prévu' : 'This is taking longer than usual'}
                        </Text>
                        <Text style={styles.pageSubtitle}>
                            {isFrench
                                ? "Vous pouvez fermer cet onglet et vérifier vos cartes cadeaux dans l'extension Joko."
                                : 'You can close this tab and check your gift cards in the Joko extension.'}
                        </Text>
                        <TouchableOpacity style={styles.closeButton} onPress={() => window.close()}>
                            <Text style={styles.closeButtonText}>
                                {isFrench ? 'Fermer cet onglet' : 'Close this tab'}
                            </Text>
                        </TouchableOpacity>
                    </View>
                ) : (
                    <LottieWithText text={cyclingText} />
                )}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    page: {
        minHeight: '100vh',
        backgroundColor: '#f7f8fa',
    },
    header: {
        paddingHorizontal: 40,
        paddingVertical: 19,
        borderBottomWidth: 1,
        borderBottomColor: '#e3e3e3',
        backgroundColor: color.white,
    },
    headerLogo: {
        width: 114,
        height: 55,
        resizeMode: 'contain',
    },
    centeredContent: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 80,
    },
    messageContainer: {
        alignItems: 'center',
    },
    pageHeading: {
        fontFamily: font.wallopSansBold,
        fontSize: 24,
        lineHeight: 29,
        letterSpacing: -0.48,
        color: color.black,
    },
    pageSubtitle: {
        fontFamily: font.ambitRegular,
        fontSize: 14,
        lineHeight: 20,
        color: color.black,
        marginTop: 4,
    },
    closeButton: {
        marginTop: 24,
        paddingVertical: 12,
        paddingHorizontal: 24,
        backgroundColor: color.black,
        borderRadius: 96,
    },
    closeButtonText: {
        color: color.white,
        fontFamily: font.ambitSemiBold,
        fontSize: 16,
    },
});
